import { Component } from 'preact';
import PropTypes from 'prop-types';
import { dawaAutocomplete } from 'dawa-autocomplete2';

import Label from '../../../Form/Label';
import { actionHandler } from '../../../../utilities/form/formUtils';
import { getSuggestionValue } from '../../../../utilities/form/autoSuggest/address.js';

class Address extends Component {

  constructor(props) {
    super(props);
    this.onSelectAutoComplete = this.onSelectAutoComplete.bind(this);
  }

  componentDidMount() {
    const {
      multiline,
      userData,
    } = this.props;

    this.dawaAutocomplete = dawaAutocomplete(this.dawaMountPoint, { 
      id: userData.addressId,
      multiline: multiline,
      select: this.onSelectAutoComplete
    });

    if (userData.addressInput && this.dawaMountPoint) {
      this.dawaMountPoint.value = decodeURIComponent(userData.addressInput);
    }
  }

  onSelectAutoComplete(selected) {
    const selection = {
      adresse: {
        ...selected?.data
      },
      tekst: selected?.tekst,
    };
    
    const {
      actions,
      dispatch,
      values, 
      setValues 
    } = this.props;

    getSuggestionValue(
      selection,
      setValues,
      values
    );

    if (actions && actions.length > 0) {
      actionHandler(actions, null, null, dispatch, values, setValues);
    }
  }

  onChange(e) {
    const currentValue = e.currentTarget.value;
    if(currentValue === "") {
      this.onSelectAutoComplete();
    }
  } 

  componentWillUnmount() {
    this.dawaAutocomplete.destroy();
  }

  render() {
    const {
      id,
      label,
      placeholder,
    } = this.props;

    return (
      <div class="form__field">
        {label &&
          <Label id={id} label={label} />
        }
        <div class="autocomplete-container form__field--textfield">
          <input
              type="text"
              class="form__item"
              id="dawa-autocomplete-input"
              ref={dawaMountPoint => this.dawaMountPoint = dawaMountPoint}
              placeholder={placeholder}
              onChange={this.onChange.bind(this)}
          />
        </div>
      </div>
    );
  }
}

export default Address;

Address.defaultProps = {
  id: null,
  name: null,
  label: null,
  placeholder: null,
  className: null,
  multiline: false,
  actions: null,
};

Address.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  multiline: PropTypes.bool,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  actions: PropTypes.array,
};
